import { Subject, BehaviorSubject } from 'rxjs'
import { TemplateRef } from '@angular/core'

export class Country {
  _id?: string
  capital?: string
  cities?: null | []
  codeAlpha2?: string
  codeAlpha3: string
  codeNumeric?: string
  continent?: string
  currencies?: null
  fullName?: string
  languages?: null | []
  name: string
  nameCN?: string
  shortName?: string
}

export interface ICountryQueryParams {
  size: number
  page: number
  keyword?: string
}

// å¸ç§ä¿¡æ¯
export class Currency {
  _id?: string
  code: string
  decimal: number
  name: string
  number: string
  sign: string
  country?: string
  countryCodeAlpha2?: string
  countryCodeAlpha3?: string
}

export interface ICurrencyQueryParams {
  limit: number
  keyword?: string
}

export interface IDetailHeaderTab {
  text: string
  url: string
  key?: string // ç¨æ¥å®ä½æä¸ª tab
}

export interface INewSelectOption {
  localName: string
  label: string
  value: string
}

export interface IExchangeRateQueryParams {
  dstCurrency: string
  srcCurrency: string
}

/* è¡¨åé¡¹ */
export enum FormItemType {
  SELECT = 'select',
  CURRENCY_SELECT = 'currency_select',
  SWITCH = 'switch',
  FILE = 'file',
  TEMPLATE = 'template',
  INPUTGROUP = 'inputGroup',
  RADIO = 'radio',
}

export interface IFormItem {
  label: string
  errTip?: string
  errTips?: { [key: string]: string }
  formControlName: string
  inputType?: string
  type?: FormItemType // è¾å¥ç±»åï¼
  multiple?: 'multiple' | 'tags' | 'default' // å½è¾å¥ç±»åæ¯ select æ¶ï¼å¯ä»¥æå®æ¯å¦å¤ä¸ª
  allowClear?: boolean // å½è¾å¥ç±»åæ¶ select æ¶ï¼æ¯å¦åè®¸å é¤
  options?: IOption[] // å½è¾å¥ç±»åæ¯ select æ¶ï¼éè¦æä¾ å¯¹åºç options
  hide?: boolean // æ¯å¦éè
  asyncHidden?: BehaviorSubject<boolean> // å¼æ­¥æ§å¶æ¯å¦éè
  disable?: boolean // æ¯å¦ä¸å¯ç¼è¾
  addAfter?: string // inputGroup åç¼
  asyncSpan?: BehaviorSubject<string> // async nzSpan value
  compareFn?: (c1, c2) => boolean // select æ¯è¾æ¹æ³
  change?: (event: any) => void // ç¨äºçå¬éæ©é¡¹ååæ¶çæä½æ¹æ³
  template?: TemplateRef<void>
  currencyType?: 'string' | 'object'
}

export interface IFormOption {
  label: string
  errTip: string
  formControlName: string
  type?: FormItemType
  multiple?: boolean
  options?: any[]
}

export interface IOption {
  label: string
  value: string | number
}

export interface ICurrencyOption {
  label: string
  value: Currency
}

/* æ¸ éä¿¡æ¯ */
export enum ChanCodeValue {
  WXP = 'WXP',
  ALP = 'ALP',
  UPI = 'UPI',
  // GRB = 'GRB',
  // WHK = 'WHK',
  // TRU = 'TRU',
  // DOT = 'DOT',
  // TIS = 'TIS',
  // CIL = 'CIL',
  // VIS = 'VIS',
  // MCC = 'MCC',
  // FPS = 'FPS',
}

export enum ChanCodeLabel {
  ALP = 'Alipay',
  WXP = 'WeChat',
  UPI = 'UPI',
  // GRB = 'GRB',
  // WHK = 'WeChat HK',
  // TRU = 'TrueMoney',
  // DOT = 'DOT',
  // TIS = 'TIS',
  // CIL = 'CIL',
  // VIS = 'Visa',
  // MCC = 'MasterCard',
  // FPS = 'FPS',
}

export enum CardChanCodeLabel {
  VIS = 'Visa',
  MCC = 'MasterCard',
  AME = 'American Express',
}

export enum CardChanCodeValue {
  VIS = 'VIS',
  MCC = 'MCC',
  AME = 'AME',
}

// æ±çï¼å¬å±æ¥å£
export interface IExchangeRate {
  buyRate: number
  createTime: string
  dstCurrency: string
  id: string
  isCalculate: boolean
  isNew: boolean
  markup: number
  rateSponsor: string
  relateRates: string[]
  selRate: number
  srcCurrency: string
  updateTime: string
}

// æ¥æéæ©
export enum EDateLimitEnum {
  Year = 'year',
  Month = 'month',
}

// ä¸å¡å±çº§
export const BizAreaOptions = [
  {
    label: 'CIL',
    value: 'CIL',
  },
  {
    label: 'THA',
    value: 'THA',
  },
  {
    label: 'TIS',
    value: 'TIS',
  },
  {
    label: 'MZH',
    value: 'MZH',
  },
  {
    label: 'IDA',
    value: 'IDA',
  },
  {
    label: 'TYO',
    value: 'TYO',
  },
  {
    label: 'SGP',
    value: 'SGP',
  }
]
// ç¶æ
export const StatusTextMap = {
  init: 'GENERAL.STATUS.INIT',
  normal: 'GENERAL.STATUS.NORMAL',
  freeze: 'GENERAL.STATUS.FREEZE',
}
// é£æ§æ¹æ¡çç¶æ
export const SchemeStatusTextMap = {
  '': '-',
  0: 'GENERAL.STATUS.NORMAL',
  1: 'GENERAL.STATUS.FREEZE',
}
// é£æ§æ¹æ¡è§åå±æ§
export const RuleTypeTextMap = {
  1: 'GENERAL.RULE_TYPE_AUTH',
  2: 'GENERAL.RULE_TYPE_SETTLEMENT',
}
// é£æ§ç±»å
export const RiskTypeMap = {
  normal: 'RISK_CTRL_CATEGORY.NORMAL',
  special: 'RISK_CTRL_CATEGORY.SPECIAL',
}
// ç¨æ·ç±»å
export const UserTypeTextMap = {
  admin: 'USERTYPE.ADMIN',
  genAdmin: 'USERTYPE.GENADMIN',
  institution: 'USERTYPE.INSTITUTION',
  agent: 'USERTYPE.AGENT',
  merchant: 'USERTYPE.MERCHANT',
  store: 'USERTYPE.STORE',
}

// å±çº§æ å°
export const LevelMap = {
  institution: 'æºæ',
  agent: 'éå¢',
  merchant: 'åæ·',
  store: 'é¨åº',
}

/** åç«¯æåä¿¡æ¯ */
export enum SuccessCode {
  SUCCESS_AUDITING = 'MSG_CODE.SYSTEM.SUCCESS_AUDITING',
  SUCCESS = 'MSG_CODE.SYSTEM.SUCCESS'
}

/** åç«¯æ¥éä¿¡æ¯ */
export enum ErrorCode {
  ALREADY_IN_AUDIT = 'MSG_CODE.PERMISSION.ALREADY_IN_AUDIT',
}

/** åé¡µ */
export interface IPagination {
  count: number,
  page: number,
  size: number,
  total: number,
}

export interface IGenericPagination<T> extends IPagination {
  data: T[],
}

// åºäºæ¸¸æ çåé¡µ
export interface ICursorPagination {
  paging: ICursorPaging
}

export interface ICursorPaging {
  cursors: ICursor,
  previous: string,
  next: string,
}

export interface ICursor {
  before: string,
  after: string,
}

/** æ¥è¯¢æ¡ä»¶ */
export interface IQueryParams {
  page: number,
  size: number,
  total?: number,
}

/** è¿åæ¥å£ */
export interface IResponse {
  status: number,
  message: string,
  data: any,
}

export interface IGeneralResponse {
  code: string,
  msg: string,
}

export interface IRoleResponse {
  agentRoles: any,
  insRoles: any,
  merchantRoles: any,
  storeRoles: any
}

export interface IReportResponse {
  url: string
}

/** æ´æ° */
export class UpdateReq {
  version: number
}
